@if (entity) {
    <div class="page-content">
        @if (appInfo.neland) {
            <div class="d-flex">
                <!-- <h1><strong>Batch</strong></h1> -->
                <div>
                    <button (click)="summaryReport()" title="Summary Report" class="btn btn-secondary btn-sm">Report</button>
                    <button (click)="copy()" class="btn btn-default btn-sm ms-2">Copy Batch</button>
                    @if (entity.statusId === 1) {
                        <button (click)="post()" class="btn btn-success btn-sm ms-4">Post Batch</button>
                    }
                    @if (entity.statusId === 1) {
                        <button (click)="voidBatch()" class="btn btn-danger btn-sm ms-2">Void Batch</button>
                    }
                </div>
            </div>
        }
        @if (appInfo.graafschap) {
            <div class="d-flex">
                <h1>
                    <strong>{{ entity.name }}</strong>
                </h1>
                <div>
                    <button (click)="changeStatus()" [hidden]="!canChangeStatus" class="btn btn-success btn-sm mt-1" style="margin-left: 25px">
                        {{ entity.statusId === 1 ? "Mark as Posted" : entity.statusId === 2 || entity.statusId === 6 ? "Mark as Completed" : "blank" }}
                    </button>
                    <button (click)="markAsTreasurerReview()" [hidden]="!canChangeStatus || entity.statusId === 6" class="btn btn-primary btn-sm mt-1" style="margin-left: 25px">
                        Mark as Treasurer Review
                    </button>
                    <button class="btn btn-secondary btn-sm mt-1" style="margin-left: 25px" (click)="close()">Close</button>
                </div>
            </div>
        }
        <div class="{{ appInfo.graafschap ? 'mt-0' : ' mt-4' }}">
            @if (!readonly) {
                <a href (click)="editBatch()">
                    <strong>{{ entity.name }}</strong>
                </a>
            }
            @if (readonly) {
                <strong>{{ entity.name }}</strong>
            }
            for {{ entity.date | date: "MM/dd/yyyy" }} ({{ entity.statusName }}
            @if (entity.bagNumber) {
                <span>, bag #{{ entity.bagNumber }} </span>
            }
            )
            @if (!appInfo.neland) {
                <span>CreatedBy: {{ entity.createdBy }}</span>
            }
        </div>
        @if (!!entity.note && appInfo.graafschap) {
            <div>Batch Note: {{ entity.note }}</div>
        }
        @if (auth.hasRole("Treasurer") || (auth.hasRole("Giving") && !reviewOnly)) {
            <div class="mt-4">
                <div class="d-flex">
                    <h2>Contributions</h2>
                    <div class="ms-4">
                        <button (click)="addContribution()" [hidden]="readonly" accesskey="a" title="Add Contribution (Alt-A)" class="btn btn-primary btn-sm">Add</button>
                        <a href (click)="toggleShowAll()" class="btn btn-sm btn-default ms-2">
                            {{ showAllContributions ? "show recent" : "show all" }}
                        </a>
                        <button
                            (click)="bulkAdd()"
                            [hidden]="!appInfo.graafschap || readonly"
                            accesskey="m"
                            title="Add Many Contributions (Alt-M)"
                            class="btn btn-primary btn-sm"
                            style="margin-left: 25px"
                        >
                            Bulk Add
                        </button>
                        <button
                            (click)="doubleCheck()"
                            [hidden]="!appInfo.graafschap || readonly"
                            accesskey="d"
                            title="Double Check Contributions (Alt-M)"
                            class="btn btn-success btn-sm"
                            style="margin-left: 25px"
                        >
                            Double Check
                        </button>
                        <button class="ms-4 btn btn-sm btn-secondary" (click)="getTotalBatchCash()">Batch Cash Summary</button>
                    </div>
                </div>
                <table class="table clearfix">
                    <thead>
                        <tr>
                            <th>From</th>
                            <th>Total</th>
                            <th>Type</th>
                            <th>Check #</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (c of contributions; track c) {
                            <tr>
                                <td>
                                    @if (appInfo.graafschap) {
                                        <a href (click)="editContributionById(c.id)">{{ c.person?.envelopeNumber }} - {{ c.person?.firstName }} {{ c.person?.lastName }}</a>
                                    }
                                    @if (!appInfo.graafschap) {
                                        <a href (click)="editContributionById(c.id)">{{ c.person ? c.person?.firstName + " " + c.person?.lastName : "(blank)" }}</a>
                                    }
                                </td>
                                <td>{{ c.totalAmount | currency }}</td>
                                <td>{{ c.type?.name }}</td>
                                <td>{{ c.checkNumber }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (false) {
            <div class="mt-4">
                <div class="d-flex">
                    <h2>Misc Payments</h2>
                    <div>
                        <button href (click)="addPayment()" [hidden]="readonly" accesskey="p" title="Add Payment (Alt-P)" class="btn btn-primary btn-sm" style="margin-left: 25px">
                            Add
                        </button>
                    </div>
                </div>
                <table class="table clearfix">
                    <thead>
                        <tr>
                            <th>From</th>
                            <th>Amount</th>
                            <th>Type</th>
                            <th>Check #</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (p of entity.payments; track p) {
                            <tr>
                                <td>
                                    <a href ng-click="vm.editPayment(p.id)">{{ p.name }}</a>
                                </td>
                                <td>{{ p.amount | currency }}</td>
                                <td>{{ p.typeName }}</td>
                                <td>{{ p.checkNumber }}</td>
                                <td>{{ p.note }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        <div class="row mt-4">
            <div class="col">
                <h3>Account Summary</h3>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Account</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (c of entity.accountTotals; track c) {
                            <tr>
                                @if (!appInfo.graafschap) {
                                    <td>{{ c.name }}</td>
                                }
                                @if (appInfo.graafschap) {
                                    <td>{{ c.name }} - {{ c.quickBooksAccount }}</td>
                                }
                                <td>{{ c.totalAmount | currency }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div class="col">
                <div class="d-flex">
                    <h3>Type Summary</h3>
                    <button
                        (click)="bankAmount()"
                        [hidden]="!reviewOnly || !appInfo.graafschap || entity.statusId !== 1"
                        accesskey="b"
                        title="Add Bank Amount (Alt-B)"
                        class="btn btn-success btn-sm"
                        style="margin-left: 25px"
                    >
                        Bank Amounts
                    </button>
                    <button
                        (click)="batchError()"
                        [hidden]="!reviewOnly || !appInfo.graafschap || entity.statusId !== 1"
                        accesskey="e"
                        title="Batch Error (Alt-E)"
                        class="btn btn-danger btn-sm"
                        style="margin-left: 25px"
                    >
                        Batch Error
                    </button>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Total</th>
                            @if (appInfo.graafschap) {
                                <th>Bank Amount</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (c of entity.typeTotals; track c) {
                            <tr>
                                <td>{{ c.name }}</td>
                                <td>{{ c.totalAmount | currency }}</td>
                                @if (appInfo.graafschap) {
                                    <td>
                                        {{
                                            c.name == "Cash"
                                                ? entity.bankCashAmount
                                                    ? (entity.bankCashAmount | currency)
                                                    : (0.0 | currency)
                                                : c.name == "Check"
                                                  ? entity.bankCheckAmount
                                                      ? (entity.bankCheckAmount | currency)
                                                      : (0.0 | currency)
                                                  : "-----"
                                        }}
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td>
                                <strong>{{ entity.totalAmount | currency }}</strong>
                            </td>
                        </tr>
                        @if (appInfo.graafschap) {
                            <tr>
                                <td>CashCheck</td>
                                <td>
                                    <strong>{{ entity.cashCheckAmount | currency }}</strong>
                                </td>
                            </tr>
                        }
                    </tfoot>
                </table>
            </div>
        </div>
        @if (appInfo.graafschap && this.batchNotes) {
            <div class="col-12">
                <div class="d-flex">
                    <h3>Batch Notes</h3>
                    <button
                        (click)="batchError(false, true)"
                        [hidden]="!appInfo.graafschap || (entity.statusId !== 1 && entity.statusId !== 2 && entity.statusId !== 5)"
                        accesskey="n"
                        title="Add Batch Note (Alt-N)"
                        class="btn btn-primary btn-sm"
                        style="margin-left: 25px; margin-bottom: 5px"
                    >
                        Add Note
                    </button>
                    <button
                        (click)="batchError(true)"
                        [hidden]="auth.hasRole('Secretary') || !appInfo.graafschap || entity.statusId !== 5"
                        accesskey="r"
                        title="Resolve Batch Error (Alt-R)"
                        class="btn btn-success btn-sm"
                        style="margin-left: 25px; margin-bottom: 5px"
                    >
                        Resolve Error
                    </button>
                </div>
                <table class="table clearfix">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>By</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (p of batchNotes; track p) {
                            <tr>
                                <td>{{ p.created | date: "MM/dd/yy hh:mm:ss a" }}</td>
                                <td>{{ p.createdBy }}</td>
                                <td>{{ p.note }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (appInfo.neland) {
            <div class="col-6">
                <div><h3>Other Contributions</h3></div>
                <table class="table clearfix">
                    <thead>
                        <tr>
                            <th>Amount</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (p of entity.otherContributions; track p) {
                            <tr>
                                <td>{{ p.amount | currency }}</td>
                                <td>{{ p.note }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
}
